module.exports = __webpack_public_path__ + "static/img/icon__products.3887bc6e.svg";